// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { Agent } from "http";
/**
 * @hidden
 */
export let defaultHttpAgent: Agent;
/**
 * @hidden
 */
export let defaultHttpsAgent: Agent;
